import React, { useState, useRef, useEffect } from 'react';
import { AnalyticsHelpers } from '../../analytics.helpers';
import { Icon } from '@doxyme/ui';
import './datepicker-block.scss';
export const DatepickerBlock = ({ onChange, options, selectedOptionKey, }) => {
    const wrapperRef = useRef();
    const cn = AnalyticsHelpers.makeAnalyticsClass('datepicker');
    const selectedOption = options.find((item) => item.key === selectedOptionKey);
    const [isDropdownOpen, setDropdownOpen] = useState(false);
    const toggleSelect = () => {
        setDropdownOpen(!isDropdownOpen);
    };
    const onDateSelect = (item) => {
        toggleSelect();
        if (onChange) {
            onChange(item);
        }
        else {
            console.log('Callback onChange wasn`t passed in props, value in datepicker is: ', AnalyticsHelpers.createPeriod(item));
        }
    };
    const handleClickOutside = (event) => {
        if (wrapperRef && !wrapperRef.current.contains(event.target)) {
            setDropdownOpen(false);
        }
    };
    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);
    return (<div className={cn('select-wrapper')} ref={wrapperRef}>
      <div className={cn('label-wrapper')} onClick={toggleSelect}>
        <h3 className={cn('label-text')}>
          {selectedOption.selectLabel || selectedOption.optionLabel}
        </h3>
        <Icon name={isDropdownOpen ? 'chevron-up' : 'chevron-down'} size="xx-small"/>
      </div>
      {isDropdownOpen && (<div className={cn('dropdown')}>
          {options.map((item) => (<button className={cn('option')} key={item.optionLabel} onClick={() => onDateSelect(item)}>
              {item.optionLabel}
            </button>))}
        </div>)}
    </div>);
};
